
export const IGV_TYPE = {
  NO_IGV: 0,  // sin igv
  MORE_IGV: 1,  // mas igv
  INCLUDED_IGV: 2,  // incluido igv
}

export const isValidIgvType = (igvType) => {
  return Object.values(IGV_TYPE).includes(igvType)
}